export default {
  count: {
    id: 'rating_stars_backers_new',
    defaultMessage: `by {count, plural,
      one {# backer}
      other {# backers}
    }`,
  },
}
